export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/promotion-img.f422bb3f.svg","height":78,"width":115};